// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"20f0b692","342":"61250bb2","401":"c376e787","789":"feeb788c","908":"163b95fe","955":"91958686"}[chunkId] + ".css";
};